const Theme = {
  defaultV2: 0,
  modern: 1,
  default: 2,
  bootstrap: 3,
  orange: 4,
  darkblue: 5,
  darkrose: 6,
  stone: 7,
  winter: 8,
  winterstone: 9
} as const;

export type ThemeValue = (typeof Theme)[keyof typeof Theme];

export default Theme;
